import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MISSIONS_CATEGORY_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useMissionsPreferredRarity } from './useMissionsPreferredRarity.ts';

type Props = { category?: string };
export const RedirectToMissionsPage = ({ category }: Props) => {
  const { generateSportContextPath } = useSportContext();

  const rarity = useMissionsPreferredRarity();

  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_MISSIONS_CATEGORY_RARITY, {
        params: {
          category: category || 'play',
          rarity,
        },
      })}
    />
  );
};
